import enOrderStepType from "../../../api/enums/enOrderStepType";
import {
    RouteLocationModelSimpleTextData,
    RouteLocationModelSimpleTextDataKeys
} from "fulogics-ui-web/dist/layout/components/route-location-model-simple-text/RouteLocationModelSimpleText";
import {keysJoin} from "fulogics-ui-core/dist/api/odata/ODataModel";

export type OrderReturnStepData = {
    id?: string,
    location?: RouteLocationModelSimpleTextData,
    plannedStartDate?: Date,
    type?: enOrderStepType,
    //    
    payload?:
        {
            id?: string,
            carrierCount?: number,
        },
}

export const OrderReturnStepDataKeys =
    [
        "id",
        "plannedStartDate",
        "type",
        "payload.id",
        "payload.carrierCount",
        ...keysJoin(RouteLocationModelSimpleTextDataKeys, "location.")]